import { useFormVehicleId } from 'pages/ListerVehicleUploadV2/hooks/useFormVehicleId';
import { SyncManager } from 'db';
import { InspectorCommentsInput } from 'pages/ListerVehicleUploadV2/InspectorComments';
import { useField } from 'react-final-form';

type Props = {
  sectionId: string;
};

export const FinalReviewInspectorNotes = ({ sectionId }: Props) => {
  const id = useFormVehicleId();

  const {
    input: { value, onChange }
  } = useField(`${sectionId}.message`, { subscription: { value: true } });

  const save = async (notes: string | null, fieldName = 'notes') => {
    onChange(notes);
    const syncManager = SyncManager.getInstance(id);
    await syncManager.queueVehicleUpdate([`${sectionId}.${fieldName}`, notes]);
  };

  return <InspectorCommentsInput saveComment={save} initialValue={value} />;
};
